
import React, { useState, useEffect, useCallback } from "react";
import logo from "../assets/vignan_online.png";
import Analytics from "../Component/sales/Analytics.jsx";
import AllReferall from "../Component/sales/AllReferall.jsx";
import Myteam from "../Component/sales/Myteam.jsx";
import Add from "../Component/sales/Add.jsx";
import DailyRedeemption from "../Component/sales/DailyRedeemption.jsx";
import AwardRule from "../Component/sales/AwardRule.jsx";
import ReferralUsers from "../Component/sales/ReferralUsers.jsx";
import { useAuth } from "../Context/AuthContext.jsx";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { useCampaign } from '../Context/CampaignContext.jsx';

const SalesDashboard = () => {
  const { token, user, setUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(1);
  const [toggletab, setToggletab] = useState(false);
  const [dashboardata, setDashboardata] = useState({});
  const { saveCampaignData, campaign, source, medium } = useCampaign();

  const getQueryParams = (key) => {
    const params = new URLSearchParams(location.search);
    return params.get(key);
  };

  const campaignParam = getQueryParams("utm_campaign") || campaign || "NA";
  const sourceParam = getQueryParams("utm_source") || source || "NA";
  const mediumParam = getQueryParams("utm_medium") || medium || "NA"

  useEffect(() => {
    saveCampaignData(sourceParam, campaignParam, mediumParam);
  }, [sourceParam, campaignParam, mediumParam, saveCampaignData]);

  // Handle activeTab from navigation state (e.g., when coming back from user detail page)
  useEffect(() => {
    if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab);
      // Clear the state after using it
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  const AllReferallInfo = useCallback(async () => {
    try {
      await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/referrals/`, {
        headers: { Authorization: `Bearer ${token}` }
      });
    } catch (error) {
      console.log("Error fetching referrals:", error);
    }
  }, [token]);

  useEffect(() => {
    AllReferallInfo();
  }, [AllReferallInfo]);

  const dashboardInfo = useCallback(async () => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/referrals/dashboard`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (resp.status === 200) {
        setDashboardata(resp.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  }, [token]);

  useEffect(() => {
    dashboardInfo();
  }, [dashboardInfo]);

  const signout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    setUser(null)
    navigate(location.state?.from?.pathname ?? "/", { replace: true });
  };

  const tabs = [
    { id: 1, label: "Analytics", icon: "M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" },
    { id: 2, label: "Referrals", icon: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" },
    // { id: 12, label: "Users", icon: "M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" },
    { id: 7, label: "My team", icon: "M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" },
    { id: 9, label: "Add", icon: "M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" },
    { id: 11, label: "Awards Rule", icon: "M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" },
    { id: 10, label: "Daily Redeemption Rule", icon: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" },
  ];

  const filteredTabs = tabs.filter(tab => {
    if (tab.label === "My team") return user.user_type === 'Admin' || user.user_type === 'SalesHead';
    if (tab.label === "Daily Redeemption Rule") return user.user_type === 'Admin';
    if (tab.label === "Analytics") return user.user_type === 'Admin' || user.user_type === 'SalesHead';
    if (tab.label === "Awards Rule") return user.user_type === 'Admin';
    if (tab.label === "Add" && user.user_type === 'DepartmentHead') return false;
    return true;
  });

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    setToggletab(false)
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col font-sans selection:bg-[#004f6b]/10 selection:text-[#004f6b]">
      {/* Premium Header */}
      <header className="sticky top-0 z-[60] bg-white border-b border-gray-100 shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07)]">
        <div className="max-w-7xl 2xl:max-w-[90rem] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            {/* Brand Section */}
            <div className="flex items-center gap-10">
              <div
                className="flex-shrink-0 cursor-pointer group"
                onClick={() => navigate('/sales')}
              >
                <img src={logo} alt="Vignan Online" className="h-10 w-auto object-contain group-hover:drop-shadow-sm transition-all" />
              </div>

              {/* User Identity */}
              <div className="hidden lg:flex items-center gap-4 py-2 px-5 bg-gray-50 rounded-2xl border border-gray-100">
                <div className="h-10 w-10 flex items-center justify-center bg-[#004f6b] text-white rounded-xl font-semibold text-lg shadow-inner">
                  {user.first_name?.charAt(0)}
                </div>
                <div className="flex flex-col text-start">
                  <p className="text-sm font-semibold text-gray-900 leading-none">{user.first_name}</p>
                  <p className="text-xs font-medium text-[#004f6b] mt-1 opacity-80">{user.user_type} Portal</p>
                </div>
              </div>
            </div>

            {/* Actions Section */}
            <div className="flex items-center gap-6">
              {/* <div className="hidden sm:flex items-center gap-2 group cursor-pointer">
                <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></div>
                <span className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Live System</span>
              </div> */}

              <button
                onClick={signout}
                className="group flex items-center gap-3 px-5 py-2.5 text-sm font-medium text-gray-600 hover:text-red-600 bg-gray-50 hover:bg-red-50 rounded-xl border border-gray-200 hover:border-red-100 transition-all active:scale-95 shadow-sm"
              >
                <span>Logout</span>
                <svg className="w-4 h-4 transform group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Modern Navigation Tabs */}
      <nav className="sticky top-20 z-50 bg-white border-b border-gray-100/80 backdrop-blur-md shadow-sm overflow-hidden">
        <div className="max-w-7xl 2xl:max-w-[90rem] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-1 overflow-x-auto py-2 scrollbar-none no-scrollbar">
            {filteredTabs.map((tab) => {
              const isActive = activeTab === tab.id;
              return (
                <button
                  key={tab.id}
                  onClick={() => handleTabClick(tab.id)}
                  className={`group relative flex-shrink-0 flex items-center gap-2.5 px-6 py-4 transition-all duration-300 ${isActive
                    ? "text-[#004f6b]"
                    : "text-black hover:text-[#004f6b]"
                    }`}
                >
                  {/* Icon */}
                  <div className={`transition-transform duration-300 ${isActive ? 'scale-110' : 'group-hover:scale-105'}`}>
                    <svg className={`w-5 h-5 ${isActive ? 'text-[#004f6b]' : 'text-black group-hover:text-[#004f6b]'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={isActive ? 2.5 : 2} d={tab.icon} />
                    </svg>
                  </div>

                  {/* Label */}
                  <span className={`text-sm font-medium tracking-tight transition-all ${isActive ? 'font-semibold opacity-100 translate-x-0' : 'opacity-80'}`}>
                    {tab.label}
                  </span>

                  {/* Active Indicator Line */}
                  {isActive && (
                    <div className="absolute bottom-0 left-4 right-4 h-1 bg-[#004f6b] rounded-t-full shadow-[0_-2px_8px_rgba(0,79,107,0.3)] anim-grow-x"></div>
                  )}
                </button>
              );
            })}
          </div>
        </div>
      </nav>

      {/* Dashboard Body Area */}
      <main className="flex-grow py-8 bg-gray-50/50">
        <div className="max-w-7xl 2xl:max-w-[90rem] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-4">
            <Analytics activeTab={activeTab} dashboardata={dashboardata} />
            <AllReferall activeTab={activeTab} />
            <ReferralUsers activeTab={activeTab} />
            <Myteam activeTab={activeTab} toggletab={toggletab} setToggletab={setToggletab} />
            <Add activeTab={activeTab} AllReferallInfo={AllReferallInfo} />
            <AwardRule activeTab={activeTab} />
            <DailyRedeemption activeTab={activeTab} />
          </div>
        </div>
      </main>

      <style jsx>{`
        @keyframes anim-grow-x {
          from { transform: scaleX(0); opacity: 0; }
          to { transform: scaleX(1); opacity: 1; }
        }
        .anim-grow-x {
          animation: anim-grow-x 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }
        .scrollbar-none::-webkit-scrollbar {
          display: none;
        }
        .no-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>
  );
};

export default SalesDashboard;
